import {
  Brand,
  Maybe,
  Store,
  PricePrice as OfferPrice,
  PriceStock,
  AlternativePrice,
  ProductMedia,
  DeliveryOption,
  ShippingCollection,
} from '../../../../../types';
import {
  PriceDisplay,
  CurrentCampaign,
  ProductPriceType,
} from '../../../types';
import { Rating } from 'components/rating/src/types';
import { HighlightedOfferType } from '../../product-highlighted-offer/types';
import { DeliveryTimeExperimentType } from 'src/hooks/experiments';

export const ProductPageProductClick = 'ProductPage';
type OnEvent = (
  e:
    | React.MouseEvent<HTMLAnchorElement, MouseEvent>
    | React.KeyboardEvent<HTMLAnchorElement>
    | React.TouchEvent<HTMLAnchorElement>
) => void;

export interface ITableLinkProps {
  rel: string;
  href: string | undefined;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown?: OnEvent;
  onTouchStart?: OnEvent;
  onKeyDown?: OnEvent;
  target: string;
  disabled: boolean;
  featured?: boolean;
}

export interface IOfferContainerProps {
  rel: string;
  to: string | undefined;
  'aria-label': string;
  isExternal: boolean;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown?: OnEvent;
  onTouchStart?: OnEvent;
  onKeyDown?: OnEvent;
  target: string;
  disabled: boolean;
  featured: boolean;
}

export enum ReportRowType {
  NONE = 'none',
  DEFAULT = 'default',
  ALTERNATIVE = 'alternative',
}

export type Align = 'left' | 'right';

export interface IPriceRowProps {
  alternativePrices?: Maybe<Array<Maybe<AlternativePrice>>>;
  brand?: Brand | null;
  brandRecommendedRetailer: boolean;
  campaign: CurrentCampaign | null;
  priceDisplay: PriceDisplay;
  deliveryOptions?: DeliveryOption[] | null;
  externalUri?: string | null;
  isInternationalPrice: boolean;
  media: ProductMedia & { first?: string | null };
  name?: string | null;
  onClickOutBounce: (id: number, priceId?: string | null) => void;
  onPriceClick: (
    featured: boolean,
    price: number | undefined,
    status: string,
    isAlternative: boolean,
    isHighlightedOffer: HighlightedOfferType | false
  ) => void;
  openInNewWindow: boolean;
  price?: OfferPrice | null;
  priceId?: string | null;
  priceType?: ProductPriceType | null;
  productId: number;
  productName?: string;
  stock?: PriceStock | null;
  store?: Store | null;
  storeInfo?: (string | null)[] | null;
  isMemberPrice: boolean;
  shipping?: ShippingCollection | null;
  deliveryTimeExperimentVal?: DeliveryTimeExperimentType;
}

export interface IStockPriceInfo {
  featured: boolean;
  campaign?: CurrentCampaign | null;
  price?: OfferPrice | null;
  priceDisplay: PriceDisplay;
  priceType?: ProductPriceType | null;
  stock?: PriceStock | null;
  isMemberPrice: boolean;
  countryCode?: string | null;
  isInternationalPrice?: boolean;
  shipping?: ShippingCollection | null;
  deliveryOptions?: DeliveryOption[] | null;
  brandRecommendedRetailer?: boolean;
}

export interface IAlternativesIndicator {
  featured: boolean;
  alternativePrices?: Maybe<Array<Maybe<AlternativePrice>>>;
}

interface ICommonColumns {
  tableLinkProps: ITableLinkProps;
  alternativePrices?: Maybe<Array<Maybe<AlternativePrice>>>;
  campaign: CurrentCampaign | null;
  priceDisplay: PriceDisplay;
  name?: string | null;
  price?: OfferPrice | null;
  priceType?: ProductPriceType | null;
  stock?: PriceStock | null;
  store?: Store | null;
  rating: Rating | undefined;
}

export interface IUnfeaturedColumns extends ICommonColumns {
  priceId?: string | null;
  priceRowRef: React.RefObject<HTMLDivElement>;
  showDisabledInfo: boolean;
  setShowDisabledInfo: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IFeaturedColumns extends ICommonColumns {
  isInternationalPrice: boolean;
  deliveryOptions?: DeliveryOption[] | null;
  brandRecommendedRetailer: boolean;
  isMemberPrice: boolean;
  shipping?: ShippingCollection | null;
  deliveryTimeExperimentVal?: DeliveryTimeExperimentType;
}
